module.exports = __webpack_public_path__ + "static/media/04_disable_Moderate.ba584daf.svg";